<template>
  <div>
    <div v-if="!player.completed_diagnostic_protocol_ids">
      <v-row class="mt-5">
        <v-col
          align="center"
          justify="center"
        >
          {{ $t('data_empty.diagnostic_stats') }}
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row>
        <v-col>
          <player-diagnostic-table
            :player="player"
            :protocol-id="protocolId"
          />
        </v-col>
      </v-row>
      <v-row class="mt-3">
        <v-spacer />
        <v-col cols="auto">
          <v-btn
            text
            class="text-none"
            color="primary"
            @click="filtersModal = true"
          >
            {{ $t("button.filters") }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div
      v-if="diagnosticStats.loading"
      class="mt-6 pa-5 d-flex justify-center align-center"
    >
      <v-progress-circular
        indeterminate
        size="150"
        width="8"
        color="grey lighten-2"
      />
    </div>
    <div v-else-if="diagnosticStats.data && diagnosticStats.data.variables && diagnosticStats.data.variables.length > 0">
      <player-diagnostic-composite-graph
        class="mt-5"
        :player="player"
        :diagnostic-stats="diagnosticStats.data"
      />

      <player-diagnostic-graphs
        :diagnostic-stats="diagnosticStats.data"
      />
    </div>

    <diagnostic-filters-dialog
      max-width="600px"
      :visible.sync="filtersModal"
      :filters.sync="filters"
      :player="player"
      @click:apply="fetchDiagnosticStats"
    />
  </div>
</template>

<script>
import { getColorForValue } from '@/utils/helpers'
import PlayerDiagnosticGraphs from '@/components/players/PlayerDiagnosticGraphs.vue'
import PlayerDiagnosticCompositeGraph from '@/components/players/PlayerDiagnosticCompositeGraph.vue'
import { PlayerApiService } from '@/data/services'
import PlayerDiagnosticTable from '@/components/players/PlayerDiagnosticTable.vue'
import DiagnosticFiltersDialog from '@/components/diagnostics/DiagnosticFiltersDialog.vue'

export default {
  name: 'PlayerDiagnosticView',
  components: {
    DiagnosticFiltersDialog,
    PlayerDiagnosticTable,
    PlayerDiagnosticCompositeGraph,
    PlayerDiagnosticGraphs
  },
  props: {
    player: {
      type: Object,
      required: true
    },
    protocolId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      variables: {
        loading: false,
        data: [],
        selected: []
      },
      diagnosticStats: {
        data: [],
        loading: true
      },
      filters: {
        teamId: null,
        date: [],
        age: [1, 100],
        sex: null,
        sportId: null,
        countryCode: null,
        rankId: null,
        positionId: null,
        eventId: null
      },
      filtersModal: false
    }
  },
  computed: {

  },
  watch: {
    player() {
      this.fetchDiagnosticStats()
    }
  },
  mounted() {
    this.fetchDiagnosticStats()
  },
  methods: {
    getColorFromValue(value, max) {
      return getColorForValue(value, max)
    },
    async fetchDiagnosticStats() {
      this.diagnosticStats.loading = true

      try {
        const filters = {
          team_id: this.filters.teamId,
          date_from: this.filters.date.length > 0 ? this.filters.date[0] : null,
          date_to: this.filters.date.length > 0 ? this.filters.date[1] : null,
          age_from: this.filters.age[0],
          age_to: this.filters.age[1],
          rank_id: this.filters.rankId,
          sport_id: this.filters.sportId,
          country_code: this.filters.countryCode,
          position_id: this.filters.positionId,
          event_id: this.filters.eventId
        }

        this.diagnosticStats.data = await PlayerApiService.getDiagnosticStats(this.player.id, filters)
      } catch (e) {
        this.diagnosticStats.data = []
        throw e
      } finally {
        this.diagnosticStats.loading = false
      }
    }

  }
}
</script>
